import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
const SUPA_URL = "https://infqeqlrjbsoenpbgkgk.supabase.co";
const SUPA_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImluZnFlcWxyamJzb2VucGJna2drIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ3NDE0MDgsImV4cCI6MjEwMDMxNzQwOH0.RRmE8CPsFHhI4XN6jCt2l2HCWSI-Vrz2wauy5mFmV5s";
// Dentro l'app nativa, la sessione va salvata con l'archiviazione vera e
// affidabile del dispositivo, non con quella del browser — dentro una
// WebView, il localStorage del browser a volte non è ancora pronto
// nell'istante esatto in cui l'app parte, facendo credere per errore che
// nessuno sia collegato. Sul sito web normale il comportamento resta
// identico a prima (localStorage), nessun cambiamento lì.
//
// AGGIORNAMENTO SICUREZZA: prima qui c'era @capacitor/preferences (Capacitor
// Preferences). Funzionava, ma su Android quel plugin scrive nello
// SharedPreferences SENZA cifratura — un dispositivo con root, o con
// accesso fisico/debug (adb), può leggere access_token e refresh_token in
// chiaro dal file. Confermato sulla documentazione ufficiale Capacitor
// (https://capacitorjs.com/docs/apis/preferences): usa SharedPreferences su
// Android e UserDefaults su iOS, nessuno dei due cifrato di per sé.
// capacitor-secure-storage-plugin usa invece Android Keystore su Android e
// Keychain su iOS — gli stessi meccanismi che usano le app bancarie per
// salvare dati sensibili sul dispositivo. Stessa identica interfaccia
// get/set/remove, quindi il cambio è "drop-in": nessun'altra riga di
// App.jsx o altrove deve cambiare.
const secureStorageAdapter = {
  getItem: async (key) => {
    try{
      const {value}=await SecureStoragePlugin.get({key});
      return value;
    }catch(e){
      // SecureStoragePlugin.get lancia un errore (invece di restituire null)
      // quando la chiave non esiste ancora — capita SEMPRE al primo avvio,
      // prima che l'utente abbia mai fatto login. Va trattato come "nessun
      // valore salvato", non come un errore vero: se propagasse, l'SDK di
      // Supabase crederebbe che la sessione sia rotta invece che assente.
      return null;
    }
  },
  setItem: async (key,value) => {
    await SecureStoragePlugin.set({key,value});
  },
  removeItem: async (key) => {
    try{ await SecureStoragePlugin.remove({key}); }catch(e){ /* già assente: va bene così */ }
  },
};
export const supa = createClient(SUPA_URL, SUPA_ANON_KEY, Capacitor.isNativePlatform() ? {
  auth: {
    storage: secureStorageAdapter,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
} : undefined);
